import { capitalize } from 'utils/string';
import { InputType, CsvLookupPreset, FieldArrayLayout } from 'types';

import { FormFieldProps } from './types';

export const inputTypeOptions = Object.values(InputType).map((value) => ({
  value,
  label: capitalize(value),
}));

export const fieldArrayLayoutOptions = Object.values(FieldArrayLayout).map(
  (value) => ({
    value,
    label: capitalize(value),
  })
);

const csvLookupPresetLabels: Record<CsvLookupPreset, string> = {
  [CsvLookupPreset.SCHOOL_LIST]: 'School List',
};

export const csvLookupPresetOptions = Object.values(CsvLookupPreset).map(
  (value) => ({
    value,
    label: csvLookupPresetLabels[value],
  })
);

export const EMPTY_OUTCOME_FIELD_SOURCES: NonNullable<
  FormFieldProps['outcomeFieldSources']
> = [];
